import React from 'react';
import RequestForm from 'components/ui/RequestForm';
import {useTariff} from 'contexts/Tariff';
import {Title, TitleSize, TitleLevel} from 'components/ui/Title';
import {TARIFFS} from 'data/tariffs';
import TelegramAction from 'components/ui/TelegramAction';
import TariffPreview from 'components/ui/TariffPreview';
import formatNumber from 'utils/formatNumber';
import Container from 'components/layout/Container';

import './TariffOrderSection.scss';

const TariffOrderSection = ({slug, innerRef, background = 'dark'}) => {
  const tariffAPI = useTariff();
  const tariff = TARIFFS[slug];
  const chosenServices = tariffAPI.getSupplements(slug);
  const hasChosenServices = chosenServices.length > 0;
  const supplementCummulativePrice = (
    hasChosenServices ? chosenServices : []
  ).reduce((prev, curr) => curr.price + prev, 0);
  const totalPrice =
    tariffAPI.tariffState.squareMeters * (tariff?.price || 0) +
    supplementCummulativePrice;

  return (
    <section
      ref={innerRef}
      id="form"
      className={`tariff-order-section tariff-order-section_${background}-bg`}
    >
      <Container>
        <Title
          extraClassName="tariff-order-section__title"
          level={TitleLevel.H2}
          size={TitleSize.H2}
        >
          {totalPrice > 0 ? (
            <>
              Ваш {tariff.name.toLowerCase()} ремонт&nbsp;—&nbsp;
              {formatNumber(totalPrice)}&nbsp;₽
            </>
          ) : (
            <>Отправьте заявку</>
          )}
        </Title>

        {slug && <TariffPreview slug={slug} />}

        {hasChosenServices && <TelegramAction background={background} />}

        {hasChosenServices && (
          <>
            <Title
              extraClassName="tariff-order-section__subtitle"
              level={TitleLevel.H3}
              size={TitleSize.H3}
            >
              Или отправьте заявку
            </Title>

            <p className="tariff-order-section__phone-caption">
              Оставьте ваш номер телефона. Мы&nbsp;перезвоним, обсудим вашу
              задачу, ответим на&nbsp;вопросы
            </p>
          </>
        )}

        <RequestForm
          slug={slug}
          showTariffInput={!slug}
          showCommentInput
          background={background}
        />
      </Container>
    </section>
  );
};

export default TariffOrderSection;
